import { render, staticRenderFns } from "./AdditionalAddressTopBar.vue?vue&type=template&id=3142f65c&scoped=true"
import script from "./AdditionalAddressTopBar.vue?vue&type=script&lang=ts"
export * from "./AdditionalAddressTopBar.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalAddressTopBar.vue?vue&type=style&index=0&id=3142f65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142f65c",
  null
  
)

export default component.exports